import { 
    useEffect,
} from 'react'

import {
    useMap,
} from 'react-leaflet'

export default function MapRecenterOnPoint({ centerOverwrite }) {
    const map = useMap()

    function getCenterFromPoints(points) {
        const p1 = points[0]
        const p2 = points[1]

        var center = [0, 0]

        center[0] = (p1[0] + p2[0]) / 2
        center[1] = (p1[1] + p2[1]) / 2

        return center
    }

    useEffect(() => {
        if (centerOverwrite[0].length !== 0 && centerOverwrite[1].length !== 0) {
            if (map.getCenter() === getCenterFromPoints(centerOverwrite))
                return

            map.setView(getCenterFromPoints(centerOverwrite), map.getZoom())
            return
        }

        if (centerOverwrite[0].length !== 0) {
            if (map.getCenter() === centerOverwrite[0])
                return

            map.setView(centerOverwrite[0])
            return
        }

        if (centerOverwrite[1].length !== 0) {
            if (map.getCenter() === centerOverwrite[1])
                return

            map.setView(centerOverwrite[1])
            return
        }
    }, [centerOverwrite])

    return null
}